module.exports = __webpack_public_path__ + "media/images/logo-cf5de26e23557c58c638dc0b653c3d21.svg";